module.exports = __webpack_public_path__ + "resources/img/img_zenius_logmanager_1_m.67051e20985169ecd6eb2edd15c2da0e.png";